import React, { useEffect, useState } from 'react';
import './Magnify.css';
export const Magnify = ({ imageUrl, zoomFactor = 1, zoomPosition = 'over', zoomWidth = 200, zoomHeight = 200, marginSize = '5px', mainImageWidth = '300px', }) => {
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [isVisible, setIsVisible] = useState(false);
    const [zoomedImageWidth, setZoomedImageWidth] = useState(zoomWidth * zoomFactor);
    const [zoomedImageHeight, setZoomedImageHeight] = useState(zoomHeight * zoomFactor);
    useEffect(() => {
        setZoomedImageWidth(zoomWidth * zoomFactor);
        setZoomedImageHeight(zoomHeight * zoomFactor);
    }, [zoomWidth, zoomHeight, zoomFactor]);
    const handleMouseMove = (event) => {
        const imageElement = event.currentTarget.querySelector('img');
        if (!imageElement)
            return;
        const imageRect = imageElement.getBoundingClientRect();
        if (event.clientX < imageRect.left ||
            event.clientX > imageRect.right ||
            event.clientY < imageRect.top ||
            event.clientY > imageRect.bottom) {
            setIsVisible(false);
            return;
        }
        const containerWidth = imageElement.offsetWidth;
        const containerHeight = imageElement.offsetHeight;
        const percentageX = (event.clientX - imageRect.left) / containerWidth;
        const percentageY = (event.clientY - imageRect.top) / containerHeight;
        const xOnZoomedImage = zoomedImageWidth * percentageX;
        const yOnZoomedImage = zoomedImageHeight * percentageY;
        const xOffset = xOnZoomedImage - zoomWidth / 2;
        const yOffset = yOnZoomedImage - zoomHeight / 2;
        const minXOffset = 0;
        const minYOffset = 0;
        const maxXOffset = zoomedImageWidth - zoomWidth;
        const maxYOffset = zoomedImageHeight - zoomHeight;
        setPosition({
            x: -Math.min(Math.max(xOffset, minXOffset), maxXOffset),
            y: -Math.min(Math.max(yOffset, minYOffset), maxYOffset),
        });
    };
    const handleMouseEnter = () => {
        setIsVisible(true);
    };
    const handleMouseLeave = (e) => {
        const relatedTarget = e.relatedTarget;
        if (relatedTarget instanceof Node &&
            e.currentTarget.contains(relatedTarget)) {
            return;
        }
        setIsVisible(false);
    };
    const getZoomPosition = () => {
        switch (zoomPosition) {
            case 'left':
                return {
                    right: `calc(100% + ${marginSize})`,
                    top: '0',
                };
            case 'right':
                return {
                    left: `calc(100% + ${marginSize})`,
                    top: '0',
                };
            case 'top':
                return {
                    bottom: `calc(100% + ${marginSize})`,
                    left: '0',
                };
            case 'bottom':
                return {
                    top: `calc(100% + ${marginSize})`,
                    left: '0',
                };
            default:
                return {
                    left: '0',
                    top: '0',
                    position: 'absolute',
                };
        }
    };
    return (React.createElement("div", { className: "magnify-container" },
        React.createElement("div", { className: "magnify-image-container", onMouseMove: handleMouseMove, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, style: zoomPosition === 'over'
                ? { overflow: 'hidden' }
                : { overflow: 'visible' } },
            React.createElement("img", { src: imageUrl, alt: "Image", style: { width: mainImageWidth } }),
            isVisible && zoomFactor > 1 && (React.createElement("div", { className: "magnify-zoom", style: {
                    ...getZoomPosition(),
                    backgroundImage: `url(${imageUrl})`,
                    backgroundPosition: `${position.x}px ${position.y}px`,
                    backgroundSize: `${zoomedImageWidth}px ${zoomedImageHeight}px`,
                    height: `${zoomHeight}px`,
                    width: `${zoomWidth}px`,
                    opacity: 1,
                } })))));
};
//# sourceMappingURL=Magnify.js.map